import React from 'react';

const Icon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="16" fill="black" fillOpacity="0.04" />
    <path
      d="M14.3346 23.0832V18.0832H17.668V23.0832H21.8346V16.4165H24.3346L16.0013 8.9165L7.66797 16.4165H10.168V23.0832H14.3346Z"
      fill="#502314"
    />
  </svg>
);

export const HomeIcon = Icon;
